<template>
<!-- Modal -->
<div class="modal fade" id="mdContent" tabindex="-1" aria-labelledby="mdContentLabel" aria-hidden="true" @click="clickModal()">
   <div class="modal-dialog modal-fullscreen-md-down">
      <div class="modal-content" id="ppeeppee">
         <a name="up"></a>
         <div class="modal-body bg-l-gray pt-0" id="element-to-pdf">     <!-- mdl-b ------->
            <!-- Portada ----------------------
            <div v-if="viewFrontPage" class="row  rw-1">
         :style="{'background-color': circleUser.bg_color , 'color': circleUser.text_color}" 
            -->
            <div v-if="content.frontPageColor" class="row rw-1 fp-height"
                     :style="{'background-color': content.frontPageColor.background}"
                     >
               <!--
                  class="col-12 row" :class=" control.items.length > 0 ? 'row-cols-3' : 'row-cols-2' "
                  bg-danger rounded"
               <div class="col-10 p-0">   <!- bg-warning ------- >
               -->
            </div>
            <!-- Cabecera ------------------------>
            <div class="row pt-2">
               <div class="col-1 hover-click" @click="editTitleIn( myCardRectangle.titleForm )">   <!-- bg-success ------->
                  <!-- Icono ------->
                  <font-awesome-icon icon="money-check" /> 
               </div>
               <div class="col-10 p-0" :class=" cancelled ? 'bg-danger px-1 rounded text-light' : '' ">   <!-- bg-warning ------->
                  <!-- Encabezado ------->
                  <div v-if="!editTitle" class="col-12">
                     <h6 class="text-break"><b><div v-html="htmlTitle(content.title)"></div></b></h6>
                  </div>
                  <!--
                     <h6 class="text-break"><b><div v-html="content.title"></div></b></h6>
                     <h6 class="text-break"><b><div v-html='content.title.replaceAll("-|-", "<span style="+"color:transparent;"+">-</span>|<span style="+"color:transparent;"+">-</span>")'></div></b></h6>
                     <h6 class="text-break"><b>{{content.title}}</b></h6>
               <div v-html="mailData.body" class="bg-light rounded my-1 ttl mt-3 p-1 fs-13 shadow"></div>
               <div class="col-1">   < !-- bg-success ------- >
                  <div v-if="!editTitle" class="col-12" @click="editTitleIn()">
                  -->
                  <div v-else class="col-12">
                     <textarea 
                        id="ta-title"
                        ref="ta_title"
                        v-model="content.title"
                        class="form-control fw-ttl p-0" 
                        rows="1" 
                        @blur="editTitleOut()"
                        @keyup="resizeTaTitle"
                     ></textarea>
                  </div>
               </div>
               <div class="col-1 d-flex justify-content-end">     <!-- bg-info ------->
                  <button type="button" class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
               </div>
            </div>
            <!-- Extenciones realizadas ------------------------>
            <div v-if="showMoveShare.extensionsMade && showMoveShare.extensionsMade.length > 0"
               class="mb-1">
               <div v-for="(extensionMade, index) in showMoveShare.extensionsMade" :key="index"
                  class="row sty-exten"
                  >
                  <div class="col-1 p-0">&nbsp;</div>
                  <div class="col-11 p-0 text-break">   <!-- bg-warning ------->
                     <i><b>{{extensionMade}}</b></i>
                  </div>
               </div>
            </div>
            <!-- Tarjeta ------------------------>
            <div class="row pt-0">
               <div class="col-1">   <!-- bg-success ------->
                  <!-- Icono ------->
                  <CardRectangle :rectangleCard="myCardRectangle" />
               </div>
               <div class="col-10 p-0">   <!-- bg-warning ------->
                  <!-- Lista ------->
                  <div class="col-12 tc-gray fs-13">en la lista <b><i>{{cell.name}}</i></b></div>     <!-- bg-orn ------->
                  <div v-if="content.id > 0" class="col-12 tc-gray fs-13">ID: <b><i>{{content.id}}</i></b></div>     <!-- bg-orn ------->
                  <div v-if="!(boards.length == 1 && editTop)" class="col-12">
                     <!-- 
                                                   :disabled="!editResto || !editOutBoard"
                     {{showMoveShare.extensions}}
                     <br>
                     <br>
                     selectBoardId.value == boardId.value
                     <br>
                     &nbsp; {{boardId}} &nbsp; {{selectBoardId}} &nbsp; {{editResto}}
                     {{showMoveShare}}
                     &nbsp; {{boardId}} &nbsp; {{boards}} 
                     <br>
                     {{cell}}
                     <br>
                     editTop: <b>{{editTop}}</b> &nbsp;editRest: <b>{{editRest}}</b> &nbsp;showRest: <b>{{showRest}}</b>
                     <br>
                     editInternal: <b>{{editInternal}}</b> &nbsp; editInBoard: <b>{{editInBoard}}</b> &nbsp; editOutBoard: <b>{{editOutBoard}}</b> &nbsp; 
                     -->
                     <!-- tableros -->    
                     <div v-if="boards"
                        class="row row-cols-auto d-flex justify-content-start pt-2 ps-1"
                        >
                        <board-rectangle 
                           v-for="(board, index) in boards" :key="index"
                           :board="board"
                           :selected="board.selected"
                           @click="selectThisBoard(index)"
                           class="ms-1 pb-1"
                           />
                     </div>
                  </div>
               </div>
            </div>
            <div v-if="content.id>0" class="row rw-3">
               <div class="col-md-9">     <!--  bg-warning ------->
                  <!-- Usuarios Participantes ------->
                  <div v-if=" selectBoardId > 0 " class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success ------->
                     <div class="col-12 col-md-11">
                        <div class="row row-cols-auto pt-1 justify-content-between">
                              <b class="tc-gray fs-11">Miembros</b>
                              <!-- Down ------->
                              <a href="#down" class="py-0">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>
                                 </svg>
                              </a>
                        </div>
                        <div class="row row-cols-auto ps-2">
                           <div v-for="(circleUser, index) in users" :key="index" class="col p-0 ms-1">
                              <userCircle :circleUser="circleUser"/>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- Etiquetas ------->
                  <div v-if=" labels.length > 0 && selectBoardId > 0 " class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success ------->
                     <div class="col-12 col-md-11">
                        <div class="row py-2">
                           <b class="tc-gray fs-11">Etiquetas</b>
                        </div>
                        <div class="row row-cols-auto ps-2 gap-0">
                           <div v-for="(label, index) in labels" 
                                 :key="index" 
                                 class="col p-0 pb-1 ms-1"
                                 >
                              <div class="bg-label text-center px-2 rounded"
                                    :style="{'background-color': label.backGroundColor, 'color': label.textColor}" 
                                    :title="'(' + label.id + ')'"
                                    >
                                 <b>{{label.name}}</b>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- Fechas -----
                  -->
                  <div v-if="content.enableDates" class="row row-cols-1 row-cols-md-2 pb-2">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success ------->
                     <div class="col-12 col-md-11">
                        <div class="row py-2">
                           <b class="tc-gray fs-11">Fechas</b>
                        </div>
                        <div class="row row-cols-auto ps-2 gap-0">
                           <div>
                              <input type="checkbox" 
                                 class="form-check-input" 
                                 :checked="content.okDate"
                                 @change="okDates()"
                                 :disabled="!editRest"
                              >
                           </div>
                           <!--
                                 id="cboDates" 
                                 value="" 
                                 aria-label="..."
                           <div>
                           <input class="form-check-input" type="checkbox" id="checkboxNoLabel" value="" aria-label="...">
                           </div>
                           <div>
                           <input class="form-check-input" type="radio" name="radioNoLabel" id="radioNoLabel1" value="" aria-label="...">
                           </div>                           -->
                           <button class="btn btn-sm btn-dates col"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasDates" 
                              aria-controls="offcanvasDates"
                              :data-cell-id="cell.id"
                              :style="{'background-color': btnDatesColor}"
                              :disabled="!editTop"
                           >
                              <b>{{dateTime(content.startDate)}} &nbsp; al &nbsp; {{dateTime(content.endDate)}}</b>
                           </button>
                           <!--
                           -->
                        </div>
                     </div>
                  </div>
                  <!-- Descripcion ------->
                  <div class="row row-cols-2">
                     <div class="col-1 dsply-out">
                        <font-awesome-icon icon="align-justify" /> 
                     </div>
                     <div class="col-1 dsply-in">
                        <font-awesome-icon icon="align-justify" /> 
                     </div>
                     <div class="col-10 pb-2">
                        <b class="tc-d-gray col-9">Descripción</b>
                     </div>
                     <!--  ------->
                     <div class="col-1 pb-2">
                        <button
                           type="button" class="btn btn-sm btn-card p-1"
                           @click="autoSize()"  
                        >
                           <svg v-if="reSize" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                           </svg>
                           <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                           </svg>
                        </button>
                     </div>
                     <!--  ------->
                  </div>
                  <!--
                        rows="1" 
                        @blur="editTitleOut()"
                           v-model="content.description"
                  -->
                  <div class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success ------->
                     <div class="col-12 col-md-11 pb-2">
                        <textarea 
                           v-model="description"
                           id="ta-description"
                           placeholder="Añadir una descripción..."
                           class="form-control bg-light tc-d-gray fs-14" 
                           rows="2"
                           @focus="editDescriptionIn()"
                           @blur="editDescriptionOut()"
                           @keyup="resizeTextarea"
                           :readonly="!editRest"

                        >
                        </textarea>
                     </div>
                  </div>
                  <!--
                           autoResize
                  <div class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 bg-success dsply-out">Spc</div>
                     <div class="col-12 col-md-11 bg-light">Contenido con espacio en blanco a la derecha</div>
                  </div>
                  Algún Contenido
                  <div class="row row-cols-2">
                     <div class="col-1 bg-success dsply-out">Iout</div>
                     <div class="col-1 bg-success dsply-in">Iin</div>
                     <div class="col-11 bg-light">Contenido con Icono interior</div>
                  </div>
                  {{content.frontPageColor}}
                        <b class="tc-d-gray col-9">{{control.wspCheckList.name}}</b>
                  <div v-if="viewAttach" class="row row-cols-2">
                  -->
                  <!-- Adjuntos ------->
                  <div v-if="viewAttach" class="row row-cols-2">
                     <div class="col-1 dsply-out">
                        <font-awesome-icon icon="paperclip" /> 
                     </div>
                     <div class="col-1 dsply-in">
                        <font-awesome-icon icon="paperclip" /> 
                     </div>
                     <div class="col-11 pb-2">
                        <b class="tc-d-gray col-9">Adjuntos</b>
                     </div>
                  </div>
                  <div v-if="viewAttach" class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success  bg-light rounded-3 border------->
                     <div class="col-12 col-md-11 pb-2">
                        <label 
                           v-for="(attach, index) in attachs" 
                           :key="index" 
                           class="col-12 row py-2"
                        >
                           <div class="col-4 col-sm-3 col-md-3">
                              <!--
                              {{attach}}
                              -->
                              <view-attach 
                                 :attach="attach" 
                                 :cell_id="cell.id"
                                 :putOff="false"
                                 :board_id="selectBoardId"
                                 />
                           </div>
                           <div class="col-7 col-sm-8 col-md-8">
                              <div class="fs-13 pt-1"><b>{{attach.name}}</b></div>
                              <div class="tc-gray fs-12"><b>{{dateTime(attach.timeStamp)}}</b></div>
                              <button v-if=" extension(attach.name) != 'jdm' " 
                                 class="btn btn-sm btn-link p-0"
                                 type="button" 
                                 data-bs-toggle="offcanvas" 
                                 data-bs-target="#offcanvasAttDelete" 
                                 aria-controls="offcanvasAttDelete"
                                 :data-cell-id="cell.id"
                                 :data-attach-id="attach.id"
                                 :data-attach-name="attach.name"
                                 :data-attach-put-off="myCardRectangle.putOff"
                                 :disabled="!editRest"
                              >
                                 {{textAttach}}
                              </button>
                              <button v-if=" extension(attach.name) != 'jdm' " 
                                 class="btn btn-sm btn-link ps-2"
                                 type="button"
                                 @click="onDownLoad(attach)"
                              >
                                 Descargar
                              </button>
                           </div>
                           <div class="col-1 text-center p-0">
                              <b class="tc-d-gray fs-13">Mail</b>
                              <input v-if=" extension(attach.name) != 'jdm' " 
                                 type="checkbox" 
                                 class="form-check-input" 
                                 :checked="attach.attachMail"
                                 @change="okAttachMail(attach.contentAttachId)"
                              >
                              <button v-if=" extension(attach.name) == 'jdm' " class="btn btn-sm btn-link ps-2"
                                 type="button"
                                 @click="openApp( 'VSM', attach.id )"
                              >
                                 Ver
                              </button>
                           </div>
                        </label>
                        <!--
                                 @change="okControl(control)"
                                 :disabled="!editRest"
                        -->
                     </div>
                  </div>
                  <!-- Check List ------->
                  <!-- 
                        class="row row-cols-2 py-2"
                  -->
                  <div 
                        v-for="(checkList, index) in checkLists" 
                        :key="index" 
                  >
                     <div class="d-flex py-2 pb-0">
                     <div class="col-1">
                        <font-awesome-icon icon="check-square" /> 
                     </div>
                     <div class="col-9 pb-1">
                        <b class="tc-d-gray col-9">{{checkList.name}} ({{checkList.id}})</b>
                     </div>
                     <div class="form-check form-switch col-1 ms-auto">
                        <input class="form-check-input" 
                           type="checkbox" 
                           role="switch" 
                           :checked="checkList.onOff"
                           @change="onOffCheckList(checkList.id, content.id)"
                           >
                     </div>
                     </div>
                     <!-- 
                        <b class="tc-d-gray fs-13 bg-info p-0">25%</b>
                              :style="{'background-color': btnDatesColor}"
                              style="width:25%;" 
                     -->
                     <div class="row row-cols-2 py-2 pt-0">
                     <div class="col-1 tc-d-gray fs-12">
                        <b>{{checkList.percent}}%</b>
                     </div>
                     <div class="col-11 pt-1 pb-2">
                        <div class="progress bg-light" style="height: 12px;">
                           <div class="progress-bar" 
                              role="progressbar" 
                              :style="{'width': checkList.percent + '%'}"
                              aria-valuemin="0" 
                              aria-valuemax="100"
                              >
                           </div>
                        </div>
                     </div>
                     </div>
                     <!-- -->
                     <div 
                           v-show="checkList.onOff"
                           v-for="(control, index) in checkList.controls" 
                           :key="index" 
                           class="col-12 row" :class=" control.items.length > 0 ? 'row-cols-3' : 'row-cols-2' "
                           >
                        <div class="col-1">
                           <input type="checkbox" 
                              class="form-check-input" 
                              :checked="control.contentCheckListControlId>0"
                              @change="okControl(control)"
                              :disabled="!editRest"
                           >
                        </div>
                        <div class="pb-2" :class=" control.items.length > 0 ? 'col-10' : 'col-11' ">
                           <div class="tc-d-gray fs-14" :class="control.contentCheckListControlId>0 ? 'text-decoration-line-through' : ''">{{control.name}}</div>
                        </div>
                        <div v-if=" control.items.length > 0 " class="col-1">
                           <button
                              type="button" class="btn btn-sm btn-card p-1"
                              @click="itemsOnOff(checkList.id, index)"  
                              >
                              <svg v-if="control.itemsOnOff" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                                 <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                              </svg>
                              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                 <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                              </svg>
                           </button>
                        </div>
                        <div v-if="control.items.length > 0 && control.itemsOnOff" class="col-12 row" >
                           <div class="col-1"></div>
                           <div class="col-11">
                              <ul class="list-group pb-1">
                                 <li class="list-group-item bg-l-gray py-1 tc-d-gray fs-14"
                                    v-for="(item, index) in control.items" 
                                    :key="index" 
                                    >{{item}}</li>
                              </ul>
                           </div>
                        </div>
                     </div>
                     <!-- 
            <div class="table-responsive" :class="cellsInBox == 2 ? 'clmn-2' : 'clmn-1'">
                           <div v-if="control.contentCheckListControlId>0" class="tc-d-gray fs-14 text-decoration-line-through">{{control.name}}</div>
                           <div v-else class="tc-d-gray fs-14">{{control.name}}</div>
                     -->
                  </div>
                     <!-- 
                  <div class="row row-cols-1">
                     <div class="col bg-light">
                        ({{content.enableCheckList}}) - 
                        {{checkLists}}
                     </div>
                  </div>
                     -->
                  <!-- Up ------->
                  <div v-if=" selectBoardId > 0 " class="row row-cols-1 row-cols-md-2 ">
                     <div class="col-md-1 dsply-out">&nbsp;</div>     <!--  bg-success ------->
                     <div class="col-12 col-md-11">
                        <div class="row row-cols-auto pt-1 justify-content-between">
                              <a name="down"></a>
                              <a href="#up" class="pb-1">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-circle" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>
                                 </svg>
                              </a>
                        </div>
                     </div>
                  </div>
                  <!-- Actividad ------->
                  <div class="row row-cols-2">
                     <div class="col-1 dsply-out">
                        <!-- Icono Externo------->
                        <font-awesome-icon icon="list" /> 
                     </div>
                     <div class="col-1 dsply-in">
                        <!-- Icono Interno------->
                        <font-awesome-icon icon="list" /> 
                     </div>
                     <div class="col-11 row p-0">
                        <b class="tc-d-gray col-9">Actividad</b>
                        <button type="button" class="btn btn-sm btn-info col-3" @click="switchDetails()">
                           {{textDetails}} detalles
                        </button>
                     </div>
                  </div>
                  <!-- Comentarios ------->
                  <div v-if="editRest" class="row row-cols-1 py-2">
                     <div class="col">
                        <div class="row">
                           <div class="col-1 pt-1 ps-2">
                              <!-- {{myCircle}} -->
                              <userCircle :circleUser="myCircle"/>
                           </div>
                           <div class="col-11">
                              <comment v-if="addComment" :cellId="cell.id"/>
                              <div v-if="!addComment" class="comment bg-light rounded-3 border p-2" @click="switchComment()">
                                 Escriba un comentario...
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- Auditoria ------- py-2 
                  <div>
                     {{details}}
                  </div>
                  -->
                     <div v-for="(detail, index) in details" :key="index" class="row row-cols-1 p-2">
                        <!--
                        -->
                        <detailView 
                           :detail="detail" 
                           :circleUser="users[detail.userIndex]" 
                           :dateTime="dateTime(detail.timeStamp)"
                           />
                     </div>
                  <!--
                     <div class="col-3 col-md-12">
                     </div>
                  -->
               </div>
               <div class="col-md-3">   <!-- bg-info"> -->
                  <div class="row row-cols-1 p-0">
                     <div class="text-center fs-13"> <b>Menú de Opciones</b></div>
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <hr class="mb-2">
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <!--
                     <div class="col-3 col-md-12 bg-orn">Menu</div>
                     -->
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasMembers" 
                           aria-controls="offcanvasMembers"
                           :data-cell-id="cell.id"
                           :disabled="!editRest || !editInternal"
                           >
                        Miembros
                     </button>
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasLabels" 
                           aria-controls="offcanvasLabels"
                           :data-cell-id="cell.id"
                           :data-card-type-id="myCardRectangle.id"
                           :data-board-id="selectBoardId"
                           :disabled=" labelLevelOneAccess ? false : (!editRest || !editInternal) "
                           >
                        Etiquetas
                     </button>
                     <!-- 
                           :disabled="!editRest || !editInternal"
                     -->
                     <!-- sacar boton/funcion para anular los checkList-->
                     <button v-if="false"
                           class="btn btn-sm btn-info col-3 col-md-12" 
                           type="button" 
                           @click="switchCheckList()"
                           >
                        {{textCheckList}} CheckList
                     </button>
                     <button v-if="myCardRectangle.dateRange > -1"
                           class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasDates" 
                           aria-controls="offcanvasDates"
                           :data-cell-id="cell.id"
                           :data-date-range="myCardRectangle.dateRange"
                           :data-disable-week-days="disabledWeekDays"
                           :disabled="!editTop || !editInternal"
                           >
                        Fechas
                     </button>
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasAttach" 
                           aria-controls="offcanvasAttach"
                           :data-cell-id="cell.id"
                           :disabled=" attachLevelOneAccess ? false : (!editRest || !editInternal) "
                           >
                        Adjuntos
                     </button>
                     <!-- 
                           :disabled="!editRest || !editInternal"
                     " control.items.length > 0 ? 'col-10' : 'col-11' "
                     -->
                     <button v-if="!myCardRectangle.frontPageColor"
                           class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasFrontPage" 
                           aria-controls="offcanvasFrontPage"
                           :data-cell-id="cell.id"
                           :disabled="!editTop || !editInternal"
                           >
                        Portada
                     </button>
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <hr class="my-2">
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasMove" 
                           aria-controls="offcanvasMove"
                           :data-cell-id="cell.id"
                           :data-cellContent-id="cellContentId"
                           :disabled="!editRest || !editInBoard"
                           >
                        Mover
                     </button>
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-toggle="offcanvas" 
                           data-bs-target="#offcanvasCopy" 
                           aria-controls="offcanvasCopy"
                           :data-cell-id="cell.id"
                           :data-cellContent-id="cellContentId"
                           :data-title-by-form="titleByForm"
                           :disabled="!editRest || boards.length > 1 || !editInBoard"
                           >
                        Copiar
                     </button>
                  </div>
                  <div v-if="showMoveShare.showButtons">
                     <div class="row row-cols-1 gap-1">
                        <hr class="my-2">
                     </div>
                     <div class="row row-cols-1 gap-1">
                        <button v-if="showMoveShare.showMove"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMoveShared" 
                              aria-controls="offcanvasMoveShared"
                              :data-move-shared="'RMV'"
                              :data-cell-id="cell.id"
                              :data-cellContent-id="cellContentId"
                              :data-card-type-id="content.wspCardType.id"
                              :disabled="!editResto || !editOutBoard || moveShareDisabled"
                              >
                           Mover a otro Tablero
                        </button>
                        <button  v-if="showMoveShare.showShare"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMoveShared" 
                              aria-controls="offcanvasMoveShared"
                              :data-move-shared="'SHR'"
                              :data-cell-id="cell.id"
                              :data-cellContent-id="cellContentId"
                              :data-card-type-id="content.wspCardType.id"
                              :disabled="!editResto || !editOutBoard || moveShareDisabled"
                              >
                           Compartir con otro Tablero
                        </button>
                        <!--
                        -->
                        <button v-if="showMoveShare.showUnShare"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMoveShared" 
                              aria-controls="offcanvasMoveShared"
                              :data-move-shared="'USH'"
                              :data-cell-id="cell.id"
                              :data-cellContent-id="cellContentId"
                              :data-card-type-id="content.wspCardType.id"
                              :disabled="!editResto || !editOutBoard || unShareDisabled"
                              >
                           Finalizar Intervención
                        </button>
                        <button v-if="showMoveShare.showUnShareAll"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              @click="unshareAll = true"
                              :title="'Finalización Automática'"
                              :disabled="!editResto || !editOutBoard || unShareDisabled"
                              >
                           Finalización Automática
                        </button>
                        <button v-if="showMoveShare.showMessage"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMessageArchive" 
                              aria-controls="offcanvasMessageArchive"
                              :data-cell-id="cell.id"
                              :data-content-id="content.id"
                              :data-card-type-id="content.wspCardType.id"
                              :data-message-archive="'MSG'"
                              :disabled="!editResto || !editOutBoard || communicationDisabled"
                              >
                           Enviar a Comunicaciones
                        </button>
                        <button v-if="showMoveShare.showUnMessage"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMoveShared" 
                              aria-controls="offcanvasMoveShared"
                              :data-move-shared="'UMS'"
                              :data-cell-id="cell.id"
                              :data-cellContent-id="cellContentId"
                              :data-card-type-id="content.wspCardType.id"
                              :disabled="!editResto || !editOutBoard"
                              >
                           Regresar al Tablero Origen
                        </button>
                        <button v-if="showMoveShare.showArchive"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMessageArchive" 
                              aria-controls="offcanvasMessageArchive"
                              :data-cell-id="cell.id"
                              :data-content-id="content.id"
                              :data-card-type-id="content.wspCardType.id"
                              :data-message-archive="'ARC'"
                              :disabled="!editResto || !editOutBoard || archiveDisabled"
                              >
                           Archivar
                        </button>
                        <button v-if="showMoveShare.showUnArchive"
                              class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              data-bs-toggle="offcanvas" 
                              data-bs-target="#offcanvasMessageArchive" 
                              aria-controls="offcanvasMessageArchive"
                              :data-cell-id="cell.id"
                              :data-content-id="content.id"
                              :data-card-type-id="content.wspCardType.id"
                              :data-message-archive="'UAR'"
                              :disabled="!editResto || !editOutBoard"
                              >
                           Regresar a Comunicaciones
                        </button>
                     </div>
                  </div>
                  <div v-if="showToPdf || showMoveShare.extensions.length > 0">
                     <div class="row row-cols-1 gap-1">
                        <hr class="my-2">
                     </div>
                     <div class="row row-cols-1 gap-1">
                        <!-- 
                        <button  v-for="(extension, index) in showMoveShare.extensions" :key="index"
                        -->
                        <div v-for="(extension, index) in showMoveShare.extensions" :key="index"
                              class="px-0">
                           <button v-show="extension.show"
                                 class="btn btn-sm btn-info col-3 col-md-12"
                                 type="button" 
                                 @click="openApp( extension.code, index )"
                                 :title='extension.name'
                                 :disabled='extension.disable || !editResto'
                                 >
                              {{extension.buttonText}}
                           </button>
                        </div>
                        <button v-if="showToPdf" class="btn btn-sm btn-info col-3 col-md-12"
                              type="button" 
                              @click="generatePDF()"
                              >
                           Exportar a PDF
                        </button>
                     </div>
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <hr class="my-2">
                  </div>
                  <div class="row row-cols-1 gap-1">
                     <!--
                     -->
                     <button class="btn btn-sm btn-info col-3 col-md-12"
                           type="button" 
                           data-bs-dismiss="modal"
                           aria-label="Close"
                           ref="btn_out_MdContent"
                            >
                        Salir
                     </button>
                  </div>
               </div>
            </div>
         </div>
         <!--
                           @click="$router.push('/boardtablelist/addV310')"
                           @click="addVoucher()"
      @cancel="addV310 = false"
         -->
      </div>
   </div>
   <!--
   <up-wizard-v-310 v-if="addV310"
      :dataFromCard="dataToV310"
      @cancel="closeUpV310()"
      />
   -->
   <router-view></router-view>

   <ocAttView />
   <ocAttDelete />
   <ocAttach />
   <ocCopy />
   <ocDates />
   <ocFrontPage />
   <ocLabels />
   <ocMembers />
   <ocMove />
   <ocMoveShared />
   <oc-message-archive />

   <!--
      @selected="(val) => upEmail(val, true)"
      @update="openApp( 'MNTF' )"
      @update="openApp( extensionApp )"
   -->
   <input-form
      v-if="inputForm" 
      :dataFromCard="dataFromCard"
      @cancel="inputForm = false"
   />
   <notification-mail-body
      v-if="notificationMailBody"
      :cardType="myCardRectangle"
      :extensionApp="extensionApp"
      @update="(val) => openApp( val )"
      @cancel="notificationMailBody = false"
   />
   <unshare-all
      v-if="unshareAll" 
      :cardType="myCardRectangle"
      :contentId="Number(contentId)"
      @update="btn_out_MdContent.click(); unshareAll = false;"
      @cancel="getCellByContent(contentId, selectBoardId); unshareAll = false;"
   />
<!-- 
      @cancel="unshareAll = false"
      class="btn btn-sm btn-info col-3 col-md-12"
-->
   <div v-if="showLeftButton" class="box" id="left">
      <button type="button" class="btn btn-primary btn-lg"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="btn_out_MdContent"
            @click="$emit('moveTo', -1)"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"/>
         </svg>
      </button>
   </div>
   <div v-if="showRightButton" class="box" id="right">
      <button type="button" class="btn btn-primary btn-lg"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="btn_out_MdContent"
            @click="$emit('moveTo', 1)"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/>
         </svg>
      </button>
   </div>
</div>
</template>

<script>
import { ref, onMounted, computed, watchEffect, nextTick } from 'vue';
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import moment from 'moment';
import axios from 'axios';
import html2pdf from 'html2pdf.js';

import WspService from "../workSpace.service";

import ocAttView from '/src/modules/workSpace/components/OcAttachView.vue';
import ocAttDelete from '/src/modules/workSpace/components/OcAttachDelete.vue';
import ocAttach from '/src/modules/workSpace/components/OcAttachContent.vue';
import ocCopy from '/src/modules/workSpace/components/OcCopyContent.vue';
import ocDates from '/src/modules/workSpace/components/OcDatesContent.vue';
import ocFrontPage from '/src/modules/workSpace/components/OcFrontPageContent.vue';
import ocLabels from '/src/modules/workSpace/components/OcLabelsContent.vue';
import ocMembers from '/src/modules/workSpace/components/OcMembersContent.vue';
import ocMove from '/src/modules/workSpace/components/OcMoveContent.vue';
import ocMoveShared from '/src/modules/workSpace/components/OcMoveShared.vue';
import comment from '/src/modules/workSpace/components/CommentContent.vue';
//import commentView from '/src/modules/workSpace/components/CommentContentView.vue';
import detailView from '/src/modules/workSpace/components/DetailContentView.vue';
import userCircle from '/src/components/UserCircle.vue';
import CardRectangle from "./CardRectangle.vue";
import ViewAttach from '../components/ViewAttach.vue';
import BoardRectangle from "./BoardRectangle.vue";
import ocMessageArchive from '/src/modules/workSpace/components/OcMessageArchive.vue';

import InputForm from './form/InputForm.vue';
import NotificationMailBody from './form/NotificationMailBody.vue';
import UnshareAll from './UnshareAll.vue';

export default {
   components: {
      comment,
      detailView,
      ocAttach,
      ocAttDelete,
      ocAttView,
      ocCopy,
      ocDates,
      ocLabels,
      ocFrontPage,
      ocMembers,
      ocMove,
      ocMoveShared,
      userCircle,
      CardRectangle,
      ViewAttach,
      BoardRectangle,
      ocMessageArchive,
      InputForm,
      NotificationMailBody,
      UnshareAll
   },
   emits: [ 'moveTo' ],
   setup() {

      const addV310 = ref(false)
      const dataToV310 = ref({})
      
      const addComment = ref(false)
      const attachs = ref([])
      const btnDatesColor = ref("#D0D3D4")
      const btn_out_MdContent = ref(null)
      const cell = ref({})
      const cellContentId = ref(0)
      const columnId = ref(0)
      const content = ref({})
      const checkLists = ref([])
      const contentId = ref(0)
      const description = ref(null)
      const descriptions = ref(null)
      const descriptionOld = ref("")
      const details = ref([])
      const disabledWeekDays = ref("false")
      const editTitle = ref(false)
      //const firstTime = ref(true)
      const fromAutoSize = ref(false)
      const labels = ref([])
      const myCircle = ref({})
      const myCardRectangle = ref({})
      const reSize = ref(false)
      const textCheckList = ref('Agregar')
      const textDetails = ref('Mostrar')
      const textAttach = ref('Quitar')
      const titleOld = ref("")
      const typeDetails = ref(3)
      const users = ref([])
      const viewAttach = ref(false)
      const viewDetails = ref(false)

      const store = useStore()
      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })
      const boardId = ref(null)
      const boards = ref([])
      const selectBoardId = ref(0)
      const editTop = ref(false)
      const editRest = ref(false)
      const showRest = ref(false)
      const showMoveShare = ref({})
      const showToPdf = ref(false)

      const editInternal = ref(true)
      const editInBoard = ref(true)
      const editOutBoard = ref(true)
      const attachLevelOneAccess = ref(false)
      const labelLevelOneAccess = ref(false)

      //const editResto = ref(false)   // ver si se utiliza, si no borrar selectBoardId.value == boardId.value
      const editResto = computed(() => {
         return selectBoardId.value == boardId.value ;
      })

      const router = useRouter()

      const moveShareDisabled = ref(false)
      const unShareDisabled = ref(false)
      const communicationDisabled = ref(false)
      const archiveDisabled = ref(false)

      const inputForm = ref(false)
      const dataFromCard = ref("{}")
      const titleByForm = ref(false)
      const notificationMailBody = ref(false)
      const extensionApp = ref('')
      const commWithBody = ref(false)
      //const isInfoMail = ref(false)

      const cancelled = ref(false)
      const unshareAll = ref(false)

      const showLeftButton = ref(false)
      const showRightButton = ref(false)

      watchEffect(() => {
         if (store.state.wspace.contentId < 0) {
            console.log("< 0: "+store.state.wspace.contentId)
            if (store.state.wspace.contentId == -1) {
               addComment.value = false;
               console.log('---- watch comment: (-1) ------');
            }
            if (store.state.wspace.contentId == -2) {
               console.log('---- watch front page: (-2) ------');
            }
            if (store.state.wspace.contentId == -3) {
               console.log('---- watch labels: (-3) ------');
            }
            if (store.state.wspace.contentId == -4) {
               console.log('---- watch dates: (-4) ------');
            }
            if (store.state.wspace.contentId == -6) {
               console.log('---- watch attach: (-6) ------');
               document.getElementById('btn_close_offcanvas_attach').click();
            }
            if (store.state.wspace.contentId == -7) {
               console.log('---- watch delete attach: (-7) ------');
               document.getElementById('btn_close_offcanvas').click();
            }
            if (store.state.wspace.contentId == -8) {
               console.log('---- watch moveTo: (-8) ------');
               btn_out_MdContent.value.click()
            }
            if (store.state.wspace.contentId == -9) {
               console.log('---- watch members: (-9) ------');
            }
            if (store.state.wspace.contentId == -10) {
               document.getElementById('bttCloseOcCopyTo').click();
               console.log('---- watch copy: (-10) ------');
            }
            if (store.state.wspace.contentId == -11) {
               getAllBoards(boardId.value, currentUserId.value, content.value.id)
               console.log('---- watch shareWith: (-11) ------');
            }
            if (store.state.wspace.contentId == -12) {
               console.log('---- watch MesageArchive: (-12) ------');
               //document.getElementById('btn_close_offcanvas').click();
               btn_out_MdContent.value.click()
            }
            if (store.state.wspace.contentId == -13) {
               console.log('---- watch V310 attach: (-13) ----');
               extensionRegister( 'V310', false )
            }
            if (store.state.wspace.contentId == -14) {
               console.log('---- watch MRCP extension: (-14) ----');
               extensionRegister( 'MRCP', false )
            }
            if (store.state.wspace.contentId == -15) {
               console.log('---- watch VALID extension: (-15) ----');
               getCellByContent(content.value.id, selectBoardId.value)
               extensionRegister( 'VALID', false )
            }
            if (store.state.wspace.contentId == -16) {
               console.log('---- watch update title: (-16) ----');
               extensionRegister( 'VALID', true )
               getCellByContent(content.value.id, selectBoardId.value)
            }
            if (store.state.wspace.contentId == -17) {
               console.log('---- watch NTBD extension: (-17) ----');
               extensionRegister( 'NTBD', false )
               /*
               if ( isInfoMail.value ) {
                  extensionRegister( 'MINF', false )
                  isInfoMail.value = false
               } else {
                  extensionRegister( 'NTBD', false )
               }
               */
            }
            if (store.state.wspace.contentId == -18) {
               console.log('---- watch MCMM extension: (-18) ----');
               if ( commWithBody.value ) {
                  extensionRegister( 'CMBD', false )
                  commWithBody.value = false
               } else {
                  extensionRegister( 'MCMM', false )
               }
            }
            if (store.state.wspace.contentId == -19) {
               console.log('---- watch MCMM extension: (-19) ----');
               extensionRegister( 'AUTH', false )
            }
            if (store.state.wspace.contentId == -20) {
               console.log('---- watch MPRQ extension: (-20) ----');
               extensionRegister( 'MPRQ', false )
            }
            if (store.state.wspace.contentId == -21) {
               console.log('---- watch MPDS extension: (-21) ----');
               extensionRegister( 'MPDS', false )
            }
            getAllContent(content.value.id)
            store.dispatch("wspace/setContentId", content.value.id)
         }
         if ( labelLevelOneAccess.value ) {
            if ( selectBoardId.value != boardId.value )  {
               labelLevelOneAccess.value = false
               attachLevelOneAccess.value = false
            }
         }
         /*
         if (editTitle.value) {
            nextTick()
            document.getElementById('ta-title').focus()
         }
         */
         /*
         console.log("watch-contentId: "+store.state.wspace.contentId);
         console.log("watch-closeComment: "+store.state.wspace.closeComment);
         console.log("watch-clickDivComment: "+store.state.wspace.clickDivComment);
         console.log('----------');
         */
      })

      onMounted(() => {
         getMyCircle()
         document.getElementById('mdContent')
         .addEventListener('show.bs.modal', function (event) {
            addComment.value = false
            let button = event.relatedTarget
            let id = button.getAttribute('data-cntt-id')
            let cellId = button.getAttribute('data-cell-id')
            cellContentId.value = button.getAttribute('data-cellContent-id')
            let showMoveTo = button.getAttribute('data-show-move-to')
            showLeftButton.value = false
            showRightButton.value = false
            if ( showMoveTo != null ) {
               if ( showMoveTo == 'B') {
                  showLeftButton.value = true
                  showRightButton.value = true
               } else {
                  if ( showMoveTo == 'L') {
                     showLeftButton.value = true
                  }
                  if ( showMoveTo == 'R') {
                     showRightButton.value = true
                  }
               }
            }
            details.value = []
            checkLists.value = []
            attachs.value = []
            viewAttach.value = false
            boardId.value = WspService.getBoardId(store)
            description.value = null
            textDetails.value = 'Mostrar'
            typeDetails.value = 3
            viewDetails.value = false
            console.log('md --> data-cell-id: '+cellId);
            console.log('md --> data-cntt-id: '+id);
            if (id == 0) {
               contentId.value = 0
               content.value = {}
               content.value.id = 0
               //content.value.title = "Agregar un titulo"
               content.value.title = "APELLIDO_NOMBRE-CUIL-aaaammdd-mail"
               columnId.value = button.getAttribute('data-column-id')
               editTitleIn()
            } else {
               editTop.value = false
               editRest.value = false
               showRest.value = false
               showMoveShare.value = {
                  showMove: false,
                  showShare: false,
                  showUnShare: false,
                  showUnMessage: false,
                  showMessage: false,
                  showArchive: false,
                  showUnArchive: false,
                  showButtons: false,
                  extensions: []
               }
               attachLevelOneAccess.value = false
               labelLevelOneAccess.value = false
               editInternal.value = true
               editInBoard.value = true
               editOutBoard.value = true
               //getFormValues( id )
               getAllBoards(boardId.value, currentUserId.value, id)
               showToPdf.value = false
               getBoard(boardId.value)               /*
               nextTick(() => {
                  getAllContent(id)
               })
               */
            }
            nextTick(() => {
               reSize.value = true
               autoSize()
            })
         })
         console.log('mounted the modal')
      })
      // A
      /*
      function addVoucher() {
         dataToV310.value = {
            cardId: contentId.value,
            cellId: cell.value.id,
            boardId: boardId.value,
            title: content.value.title
         }
         nextTick(() => {
            //router.push('/boardtablelist/addV310')
            router.push('/boardtablelist/addV310?dfc=' + JSON.stringify( dataToV310.value ))
            //this.$router.push("/profile");
            //addV310.value = true
         })
      }
      */
      function autoSize() {
         reSize.value = !reSize.value
         let elem = document.getElementById('ta-description')
         if (elem) {
         fromAutoSize.value = true
         //document.getElementById('ta-description').dispatchEvent(new Event("keyup"))
         elem.dispatchEvent(new Event("keyup"))
         console.log('reSize: '+reSize.value)
         }
      }

      function resizeTextarea(event) {
         let area = event.target;
         if (fromAutoSize.value) {
            if (reSize.value) {
               area.style.overflow = 'hidden';
               area.style.height = area.scrollHeight + 'px';
            } else {
               area.style.overflow = 'auto';
               area.style.height = '84px';
            }
            fromAutoSize.value = false
         } else {
            area.style.overflow = 'hidden';
            area.style.height = area.scrollHeight + 'px';
            reSize.value = true
         }
      }

      function resizeTaTitle(event) {
         let area = event.target;
         area.style.overflow = 'hidden';
         area.style.height = area.scrollHeight + 'px';
      }
      // c
      function clickModal() {
         
         if (
               store.state.wspace.closeComment && 
               !store.state.wspace.clickDivComment &&
               addComment.value
            ) {
            store.dispatch("wspace/setCloseComment", false)
            addComment.value = false;
         //console.log('clickModal('+store.state.wspace.closeComment+')('+store.state.wspace.clickDivComment+')');
         }
         
         console.log('clickModal('
            +store.state.wspace.closeComment+')('
            +store.state.wspace.clickDivComment+')('
            +addComment.value+')');
         //console.log('clickModal('+store.state.wspace.closeComment+')('+addComment.value+')');
         console.log('-----('+content.value.id+')-----');
         store.dispatch("wspace/setClickDivComment", false)
         //
         if (store.state.wspace.offCanvasOpen == 4) {
            document.getElementById('btn_close_offcanvas').click();
            store.dispatch("wspace/setOffCanvas", 0)
         }
      }
      function closeUpV310() {
         getAttachs(boardId.value, contentId.value)
         addV310.value = false
      }
      // D
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY HH:mm');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }
      // E
      function editDescriptionIn() {
         descriptionOld.value = description.value
         reSize.value = false
         autoSize()
      }

      function editDescriptionOut() {
         console.log(document.getElementById('ta-description').value)
         if (descriptionOld.value != document.getElementById('ta-description').value) {
            let cnttData = {}
               cnttData.description = document.getElementById('ta-description').value
            WspService.upContent(
               content.value.id,    // contentId,
               cell.value.id,    // cellId,
               boardId.value,  // boardId
               'DSC',   // code
               cnttData    // cnttData
               )
            .then(response => {
               console.log("upDescription Id: "+response.data)
            })
            .catch(error => {
               console.log(error);
            });
         }
         //editTitle.value = false
      }

      function editTitleIn( titleForm ) {
         console.log(titleForm)
         console.log(titleByForm.value)
         if (editTop.value && editInternal.value) {
            if ( titleForm == 'T' || !titleByForm.value ) {
               editTitle.value = true
               nextTick(() => {
                  titleOld.value = content.value.title
                  document.getElementById('ta-title').focus()
                  document.getElementById('ta-title').dispatchEvent(new Event("keyup"))
               })
            } else {
               openApp( 'UpTitle', -1 )
            }
         }
      }
      
      function editTitleOut() {
         console.log(document.getElementById('ta-title').value)
         if (titleOld.value != document.getElementById('ta-title').value) {
            /*
            */
            let cnttData = {}
               cnttData.columnId = columnId.value
               cnttData.userId = currentUserId.value
               cnttData.title = document.getElementById('ta-title').value
            WspService.upContent(
               content.value.id,    // contentId,
               cell.value.id,    // cellId,
               boardId.value,  // boardId
               'TTL',   // code
               cnttData    // cnttData
               )
            .then(response => {
               console.log("upContent Id: "+response.data)
               if (response.data > 0)
                  getAllContent(response.data)
            })
            .catch(error => {
               console.log(error);
            });
         }
         editTitle.value = false
      }

      function extension(fileName) {
         let exten = fileName.lastIndexOf(".");
         if (exten == -1) {
            return ""; // empty extension
         }
         return fileName.substring(exten+1);
      }

      function extensionRegister( code, _delete ) {
         WspService.extensionRegister({
            contentId: content.value.id,
            extensionCode: code,
            boardId: boardId.value,
            cellId: cell.value.id,
            userId: currentUserId.value,
            delete: _delete
         })
         .then(() => {
            console.log("extensionRegister: "+code)
            getAllContent(content.value.id)
            //getShowMoveShare( selectBoardId.value, contentId, cell.value.id )
            getAllBoards(boardId.value, currentUserId.value, content.value.id)
         })
         .catch(error => {
            console.log(error);
         });
      }
      // G
      async function generatePDF() {
         /*
         let element = document.getElementById('element-to-print');
         let opt = {
            margin:       0,
            enableLinks: false,
            filename:     String( contentId.value ) + '.pdf',
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 2 },
            jsPDF:        { orientation: 'portrait' }
         };
         // New Promise-based usage:
         //html2pdf().set(opt).from(element).save().catch(err => console.log(err));
         //
         html2pdf().set(opt).from(element).toContainer().toCanvas().toImg().toPdf().save().catch(err => console.log(err))
         */
         //
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         //let file = new File([blob], 'pepitito.pdf',  { type: 'application/pdf' })
         let file = new File([blob], String( contentId.value ) + '.pdf',  { type: 'application/pdf' })
         //
         // Create a download link for the resulting PDF Blob and trigger the download
         const downloadLink = document.createElement('a');
         downloadLink.href = URL.createObjectURL(file);
         downloadLink.download = file.name;
         downloadLink.onclick = () => downloadLink.remove();
         document.body.appendChild(downloadLink);
         downloadLink.click();
         //
         /*
         WspService.addAttachContent(
            779,     // contentId, 
            2,    // cellId,
            1,
            1,     // userId, 
            file   // attachFile
         )
         .then(response => {            
            console.log(response.data)
            console.log("attach ok: ")
         })
         .catch(error => {
            console.log(error);
         });
         */
         //         
      }

      /** Creates the PDF report document.
          * return Promise: resolves if PDF report generates successfully,
          * otherwise rejects. */
      function createPDF() {
         //return new Promise(async (resolve, reject) => {
         return new Promise( (resolve, reject) => {
            console.log('create PDF function executed!');
            let element = document.getElementById('element-to-pdf');

            let opt = {
                margin: 0,
               enableLinks: false,
                //filename: String( contentId.value ) + '.pdf',
                image: {type: 'jpeg', quality: 0.95},
                html2canvas: {scale: 2, useCORS: true},
                jsPDF: {format: 'a4', orientation: 'portrait'}
            };

            try {
                //const blob = await html2pdf().set(opt).from(element).outputPdf('blob', String( contentId.value ) + '.pdf');
                //const blob = html2pdf().set(opt).from(element).outputPdf('blob', String( contentId.value ) + '.pdf');
                const blob = html2pdf().set(opt).from(element).outputPdf('blob');
                resolve(blob);
            } catch (e) {
                reject(e);
            }
         });
      }

      // GET
      function getAllBoards(boardId, userId, contentId) {
         WspService.getAllBoards(boardId, userId, contentId)
         .then(response => {
            boards.value = response.data
            //console.log(response.data)
            nextTick(() => {
               selectBoardId.value = 0
               for (let key = 0; key < boards.value.length; key++) {
                  if (boards.value[key].selected) {
                     setEditValues(boards.value[key])
                     selectBoardId.value = boards.value[key].id
                  }
               }
            })
            nextTick(() => {
               getCellByContent(contentId, selectBoardId.value)
               getAllContent(contentId)
               getFormValues( contentId )
            })
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getAllContent(id) {
         contentId.value = id
         editTitle.value = false
         columnId.value = 0
         store.dispatch("wspace/setContentId", id)
         getContent(id)
         //details.value = []
         if (showRest.value) {
            getUsers(selectBoardId.value, id)
            getLabels(selectBoardId.value, id)
            getDescriptions(selectBoardId.value, id)
            getAttachs(selectBoardId.value, id)
            //getContentAudit(id, typeDetails.value)
            setTimeout(getContentAudit, 100, id, typeDetails.value)
         }
         console.log("getAllContent(id): "+store.state.wspace.contentId)
      }

      function getBoard(board_id) {
         WspService.getBoard(board_id).then(
            (response) => {
               console.log(response.data);
               showToPdf.value = response.data.columns == 0
            },
            (error) => {
               console.log(error.status);
            }
         );
      }

      function getFormValues( contentId ) {
         WspService.getFormValues( contentId )
         .then(response => { 
            titleByForm.value = ( response.data !== "" ) 
            if ( titleByForm.value ) {
               cancelled.value = response.data.cancelled
            }
            })
         .catch(error => { console.log(error) })
      }

      function getShowMoveShare( boardId, contentId, cellId ) {
         console.log(cellId)
         console.log(boardId)
         if (cellId == undefined) {
            cellId = 0
         }
         WspService.getShowMoveShare( boardId, contentId, cellId )
         .then(response => {
            console.log(response.data)
            nextTick(() => {
               showMoveShare.value = response.data
               // showMoveShare.showUnMessage
               if ( cell.value.isCommunication && !showMoveShare.value.showArchive ) {
                  editInBoard.value = false
                  editTop.value = false
                  editRest.value = false
               }

               moveShareDisabled.value = false
               unShareDisabled.value = false
               communicationDisabled.value = false
               archiveDisabled.value = false
               showMoveShare.value.extensions.forEach((item) => {
                  if ( !item.canMoveShare ) {
                     moveShareDisabled.value = true
                  }
                  if ( !item.canUnshare ) {
                     unShareDisabled.value = true
                  }
                  if ( !item.canCommunication ) {
                     communicationDisabled.value = true
                  }
                  if ( !item.canArchive ) {
                     archiveDisabled.value = true
                  }
               })
               /*
               if ( selectBoardId.value == boardId.value ) {
                  editResto.value = true
               }
               if ( ( cell.value.isCommunication || cell.value.isArchive ) &&
                      selectBoardId.value == boardId.value ) {
                  editResto.value = true
               }
               */
               //
            })
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getAttachs(boardId, contentId) {
         WspService.getAttachs(boardId, contentId, false)
         .then(response => {
            console.log(response.data)
            attachs.value = response.data
            if (attachs.value.length > 0)
               viewAttach.value = true
         })
         .catch(error => {
            console.log(error);
         });
      }
      //function getCell(cellId) {
      function getCellByContent(contentId, boardId) {
         //WspService.getCell(cellId)
         if (boardId > 0) {
            WspService.getCellByContentIdAndBoardId(contentId, boardId)
            .then(response => {
               console.log(response.data)
               cell.value = response.data
               //console.log("cellId ok: "+cellId)
               editInternal.value = true
               editInBoard.value = true
               editOutBoard.value = true
               attachLevelOneAccess.value = false
               labelLevelOneAccess.value = false
               if (cell.value.disableGroupButtons) {
                  
                  if (cell.value.disableGroupButtons.indexOf("O") > -1) {
                     editInternal.value = false
                  }
                  if (cell.value.disableGroupButtons.indexOf("I") > -1) {
                     editInBoard.value = false
                  }
                  if (cell.value.disableGroupButtons.indexOf("E") > -1) {
                     editOutBoard.value = false
                  }
                  if (cell.value.disableGroupButtons.indexOf("A") > -1) {
                     if (cell.value.disableGroupButtons.indexOf("-A") > -1) {
                        attachLevelOneAccess.value = true
                     }
                  }
                  if (cell.value.disableGroupButtons.indexOf("L") > -1) {
                     if (cell.value.disableGroupButtons.indexOf("-L") > -1) {
                        labelLevelOneAccess.value = true
                     }
                  }
                  
               }
               if (cell.value.isArchive) {
                  editTop.value = false
                  editRest.value = false
               }
               getShowMoveShare( selectBoardId.value, contentId, cell.value.id )
            })
            .catch(error => {
               console.log(error);
            });
         }
      }

      function htmlTitle( text ) {
         if ( text !== undefined ) {
            return WspService.htmlSeparator( text )
         }
      }

      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            //content.value.title = WspService.htmlSeparator( content.value.title )
            //
            getMyCardRectangle(content.value.wspCardType.id)
            //
            if (content.value.okDate) {
               btnDatesColor.value = "#33CC66"
            } else {
               btnDatesColor.value = "#D0D3D4"
               let today = new Date()
                  today.setHours(0,0,0,0)
               let endDt = new Date(content.value.endDate)
                  endDt.setHours(0,0,0,0)
               if (today.getTime() == endDt.getTime())
                  btnDatesColor.value = "#FFFF00"
               if (today.getTime() > endDt.getTime())
                  btnDatesColor.value = "#FF3333"
            }
            //
            if (!content.value.title)
               content.value.title = "Ingresar un titulo..."
            //
            //<!-- sacar boton/funcion para anular los checkList-->
            textCheckList.value = content.value.enableCheckList ? 'Quitar' : 'Agregar'
            // ver de ubicar lo que sigue en otro lado
            if (showRest.value) {
               //getCheckList(selectBoardId.value, content.value.wspCardType.id, content.value.id)
               setTimeout(getCheckList, 100, selectBoardId.value, content.value.wspCardType.id, content.value.id)
               //getCheckList(selectBoardId.value, content.value.wspCardType.id, content.value.id)
            }
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getContentAudit(contentId, auditTypeId) {
         WspService.getContentAudit(selectBoardId.value, contentId, auditTypeId)
         .then(response => {
            getUsers(selectBoardId.value, contentId)
            console.log(response.data)
            details.value = response.data
            console.log("Content-Audit OK ")
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getCheckList(boardId, cardTypeId, contentId) {
         console.log('checkList')
         if (content.value.enableCheckList) {
            console.log('if checkList')
            WspService.getCheckList(boardId, cardTypeId, contentId)
            .then(response => {
               console.log(response.data)
               checkLists.value = response.data
            })
            .catch(error => {
               console.log(error);
            });
         }
      }

      function getDescriptions(boardId, contentId) {
         console.log("getDescriptions: "+boardId+","+contentId)
         description.value = ""
         WspService.getDescriptions(boardId, contentId)
         .then(response => {
            console.log(response.data)
            if (response.data)
               description.value = response.data.description
            descriptions.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getLabels(boardId, contentId) {
         console.log("getLabels: "+boardId+","+contentId)
         WspService.getLabels(boardId, contentId)
         .then(response => {
            console.log(response.data)
            labels.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getMyCircle() {
         //myCircle.value = currentUserId;
         console.log(currentUserId.value)
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
            console.log("myCircle ok: ")
         })
         .catch(error => {
            console.log(error);
         });
         
      }

      function getMyCardRectangle(id) {
         //console.log(currentUserId.value)
         
         WspService.getMyCardRectangle(id)
         .then(response => {
            console.log(response.data)
            myCardRectangle.value = response.data
            disabledWeekDays.value = "false"
            if (myCardRectangle.value.businessDays) {
               disabledWeekDays.value = "true"
            }
            textAttach.value = myCardRectangle.value.putOff ? 'Quitar' : 'Borrar'
            console.log("myCardRectangle ok: ")
         })
         .catch(error => {
            console.log(error);
         });
         
      }

      function getUsers(boardId, contentId) {
         WspService.getUsers(boardId, contentId)
         .then(response => {
            console.log(response.data)
            users.value = response.data
            console.log("users-len: "+users.value.length)
         })
         .catch(error => {
            console.log(error);
         });
      }
      // I
      function isImage (fileName) {
         let imageFileExten = ".pdf.jpg.apng.avif.gif.jpeg.jfif.pjpeg.pjp.png.svg.webp.bmp.ico.cur.tif.tiff."
         if (imageFileExten.lastIndexOf(extension(fileName.toLowerCase())) > 0) {
            return true
         }
         return false
      }

      function itemsOnOff ( checkListId, index ) {
         let onOffValue = checkLists.value.find(item => item.id == checkListId).controls[index].itemsOnOff
         checkLists.value.find(item => item.id == checkListId).controls[index].itemsOnOff = !onOffValue
         //console.log(checkLists.value.find(item => item.id == checkListId).controls[index].name)
      }
      // O
      function okAttachMail( id ) {
         console.log(id)
         //attachs.value = []
         getAttachs(selectBoardId.value, content.value.id)
         WspService.attachMail( id )
         .then( () => {
            getAttachs(selectBoardId.value, content.value.id)
         })
         .catch(error => { console.log(error) })
      }
      
      function okControl(ctrol) {
         console.log("control: "+ctrol.name)
         
         let cnttData = {}
            cnttData.contentCheckListControlId = ctrol.contentCheckListControlId
            cnttData.checkListControlId = ctrol.checkListControlId
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            content.value.id,    // contentId,
            cell.value.id,    // cellId,
            boardId.value,  // boardId
            'CRL',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("Ok-Control > Id: "+response.data)
            getCheckList(selectBoardId.value, content.value.wspCardType.id, response.data)
            getContentAudit(response.data, typeDetails.value)
         })
         .catch(error => {
            console.log(error);
         });
         
      }

      function okDates() {
         let cnttData = {}
            cnttData.okDate = !content.value.okDate
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            content.value.id,    // contentId,
            cell.value.id,    // cellId,
            boardId.value,  // boardId
            'DTK',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("Ok-Dates > Id: "+response.data)
            getContent(response.data)
            store.dispatch("wspace/setContentId", -4)
         })
         .catch(error => {
            console.log(error);
         });
         //store.dispatch("wspace/setContentId", -4)

      }

      function onDownLoad(attach) {
         // process.env.VUE_APP_BASE_CNTT_ATT_FOLDER
         //let pathAttach='/WorkSpace/Content/Attach/' + attach.id + "_" + attach.name
         // //let pathAttach = process.env.VUE_APP_BASE_CNTT_ATT_FOLDER + attach.id + "_" + attach.name
         // //let pathAttach = "http://192.168.100.228:8081/WorkSpace/Content/Attach/1083_Copy%23con%23.jpg"
         let pathAttach = encodeURIComponent(process.env.VUE_APP_BASE_CNTT_ATT_FOLDER + attach.id + "_" + attach.name)
         console.log(pathAttach)
         axios({
            //url: 'http://192.168.100.208:8081/vue-favicon.ico',
            //url: 'http://192.168.100.208:8081' + pathAttach,
            url: pathAttach,
            method: 'GET',
            responseType: 'blob',
         }).then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', attach.name);
            document.body.appendChild(fileLink);

            fileLink.click();
         });
      }

      function onOffCheckList(checkListId, contentId) {
         WspService.onOffCheckList(checkListId, contentId)
         .then(() => {
            getCheckList(selectBoardId.value, content.value.wspCardType.id, content.value.id)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function openApp( code, index ) {
         if ( code == 'V310') {
            router.push('/boardtablelist/addV310?dfc=' + JSON.stringify( {
               cardId: contentId.value,
               cellId: cell.value.id,
               boardId: boardId.value,
               title: content.value.title
            } ))
         }
         if ( code == 'UpTitle') {
            router.push('/boardtablelist/form?dfc=' + JSON.stringify( {
               cardId: contentId.value,
               cardTypeID: myCardRectangle.value.id,
               cellId: cell.value.id,
               typeForm: 'T'
            } ))
         }
         if ( code == 'MRCP') {
            router.push('/boardtablelist/mrcp?dfc=' + JSON.stringify( {
               cardTypeId: content.value.wspCardType.id,
               mailType: 'RCP',
               contentId: content.value.id,
               cellId: cell.value.id,
               boardId: boardId.value,
               bodyText: null,
               attachId: 0
            } ))
         }
         if ( code == 'CMBD') {
            commWithBody.value = true
            extensionApp.value = 'MCMM'
            notificationMailBody.value = true
         }
         if ( code == 'MCMM') {
            notificationMailBody.value = false
            router.push('/boardtablelist/mrcp?dfc=' + JSON.stringify( {
               cardTypeId: content.value.wspCardType.id,
               mailType: 'CMM',
               contentId: content.value.id,
               cellId: cell.value.id,
               boardId: boardId.value,
               bodyText: store.state.wspace.updateDraftNotification,
               attachId: 0
            } ))
            extensionApp.value = ''
         }
         if ( code == 'NTBD') {
            extensionApp.value = 'MNTF'
            notificationMailBody.value = true
         }
         if ( code == 'MNTF') {
            notificationMailBody.value = false
            router.push('/boardtablelist/mrcp?dfc=' + JSON.stringify( {
               cardTypeId: content.value.wspCardType.id,
               mailType: 'NTF',
               contentId: content.value.id,
               cellId: cell.value.id,
               boardId: boardId.value,
               bodyText: store.state.wspace.updateDraftNotification,
               attachId: 0
            } ))
            extensionApp.value = ''
         }
         if ( code == 'MINF') {
            //isInfoMail.value = true
            notificationMailBody.value = false
            router.push('/boardtablelist/mrcp?dfc=' + JSON.stringify( {
               cardTypeId: content.value.wspCardType.id,
               mailType: 'INF',
               contentId: content.value.id,
               cellId: cell.value.id,
               boardId: boardId.value,
               bodyText: store.state.wspace.updateDraftNotification,
               attachId: 0
            } ))
            extensionApp.value = ''
         }
         if ( code == 'VSM') {
            router.push('/boardtablelist/mrcp?dfc=' + JSON.stringify( {
               cardTypeId: content.value.wspCardType.id,
               mailType: 'VSM',
               contentId: content.value.id,
               cellId: cell.value.id,
               boardId: boardId.value,
               bodyText: null,
               attachId: index
            } ))
         }
         //if ( code == 'VALID') {
         if ( '.VALID.AUTH.MPRQ.MPDS.'.indexOf( code ) > -1 ) {
            //console.log(index)
            //console.log( showMoveShare.value.extensions[ index ].formParameters )
            let dataCard = {
               cardId: contentId.value,
               cardTypeID: myCardRectangle.value.id,
               cellId: cell.value.id,
               typeForm: 'F',
               extensionCode: showMoveShare.value.extensions[ index ].code,
               extensionName: showMoveShare.value.extensions[ index ].name,
               formParameters: showMoveShare.value.extensions[ index ].formParameters
            }
            dataFromCard.value = JSON.stringify( dataCard )
            inputForm.value = true
         }
      }
      // S
      async function selectThisBoard(index) {
         if (viewDetails.value) {
            switchDetails()
         }
         await nextTick()
         if (boards.value[index].canShow) {
            details.value = []
            selectBoardId.value = 0
            for (let key = 0; key < boards.value.length; key++) {
               boards.value[key].selected = false
               if (key == index) {
                  //
                  setEditValues(boards.value[key])
                  selectBoardId.value = boards.value[key].id
                  //
               }
            }
            nextTick(() => {
               getCellByContent(contentId.value, selectBoardId.value)
               getAllContent(contentId.value)
            })
         }
      }

      function setEditValues(board) {
         editTop.value = false
         editRest.value = false
         showRest.value = false
         board.selected = true
         if (board.id == boardId.value) {
            editRest.value = true
            showRest.value = true
            if (board.startTheCard) {
               editTop.value = true
            }
         } else {
            if (board.canShow) {
               showRest.value = true
            }
         }
         if (!board.cardIsHere) {
            editTop.value = false
            editRest.value = false
         }
      }

      function switchComment() {
         addComment.value = true
         store.dispatch("wspace/setContentId", content.value.id)
         store.dispatch("wspace/setCloseComment", false)
         console.log('comment/description');
      }
      //<!-- sacar boton/funcion para anular los checkList-->
      function switchCheckList() {
         content.value.enableCheckList = !content.value.enableCheckList
         textCheckList.value = content.value.enableCheckList ? 'Quitar' : 'Agregar'
         if (!content.value.enableCheckList)
            checkLists.value = []
         //
         let cnttData = {}
            cnttData.enableCheckList = content.value.enableCheckList
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            content.value.id,    // contentId,
            cell.value.id,    // cellId,
            boardId.value,    // boardId
            'CHL',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("Ok-CheckList > Id: "+response.data)
            getContent(response.data)
            getContentAudit(response.data, typeDetails.value)
            //store.dispatch("wspace/setContentId", -4)
         })
         .catch(error => {
            console.log(error);
         });
         //
         getCheckList(selectBoardId.value, content.value.wspCardType.id, content.value.id);
      }

      function switchDetails() {
         viewDetails.value = !viewDetails.value
         textDetails.value = viewDetails.value ? 'Ocultar' : 'Mostrar'
         typeDetails.value = viewDetails.value ? 0 : 3
         getContentAudit(content.value.id, typeDetails.value);
      }

      return {
         addV310,
         addComment,
         archiveDisabled,
         attachs, attachLevelOneAccess,
         autoSize,
         boardId,
         boards,
         btnDatesColor,
         btn_out_MdContent,
         cancelled,
         cell,
         cellContentId,
         clickModal,
         closeUpV310,
         communicationDisabled,
         content,
         contentId,
         checkLists,
         currentUserId,
         dataFromCard, dataToV310,
         dateTime,
         description,
         descriptions,
         details,
         disabledWeekDays,
         editDescriptionIn,
         editDescriptionOut,
         editInBoard,
         editInternal,
         editOutBoard,
         editRest,
         editResto,
         editTitle,
         editTitleIn,
         editTitleOut,
         editTop,
         extension, extensionApp,
         extensionRegister,
         generatePDF, getCellByContent,
         htmlTitle,
         inputForm, isImage, itemsOnOff,
         labels, labelLevelOneAccess,
         moveShareDisabled,
         myCardRectangle,
         myCircle,
         notificationMailBody,
         okAttachMail,
         okControl,
         okDates,
         onDownLoad,
         onOffCheckList,
         openApp,
         publicPath: process.env.BASE_URL,
         reSize,
         resizeTaTitle,
         resizeTextarea,
         selectBoardId,
         selectThisBoard,
         showLeftButton, showMoveShare, showRest, showRightButton, showToPdf,
         switchComment,
         switchCheckList,
         switchDetails,
         textAttach,
         textCheckList,
         textDetails,
         titleByForm,
         unshareAll, unShareDisabled,
         users,
         viewAttach,
         viewDetails,
      }
   }
}
</script>

<style scoped>
.bg-label {
   width: auto;
   height: 22px;
   font-size: 13px;
   /*color: white;
   background-color: burlywood;*/
}
.sty-exten {
   width: auto;
   height: 17px;
   font-size: 13px;
}
.offcanvas-end {
  top: 150px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.btn-fp {
   /*
   background-color: black;
   opacity: .18;
   color: black;
   color: darklategray;
   color: whitesmoke;
   */
   background: rgba(0, 0, 0, .12);
   color: black;
}
.fp-height {
   height: 116px;
}
.comment {
   min-height: 36px;
   font-size: 14px;
   color: darkslategray;
}
.btn {
   box-shadow: none;
}
.btn-info {
   background-color: #e5e7e9; /*#e5e7e9;*/
   border-color: #B0BEC5; /*#e5e7e9;*/
}
.btn-info:hover {
   background-color: #B0BEC5; /*#cacfd2 ;*/
}
.btn-dates {
   opacity: .7;
}
.btn-dates:hover {
   opacity: 1;
}
.bg-orn {
   background-color: orange;
}   
.mdl-b {
   background-color: yellowgreen;
}
.bg-l-gray {
   background-color:  #ecf0f1 ;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.img-attach {
   height: 82px;
   width: 112px;
   background-color: #e5e7e9;
}
.fw-ttl {
   font-weight: 700;
}
@media (min-width: 768px) {
   .modal-dialog {
      min-width: 768px;
   }
   .dsply-in {
      display: none;
   }
}
@media (max-width: 767px) {
   .dsply-out {
      display: none;
   }
}
.hover-click:hover {
   cursor: pointer;
}
#left {
  position: fixed;
  top: 50vh;
  left: 10px;
}
#right {
  position: fixed;
  top: 50vh;
  right: 10px;
}
</style>